<template>
  <div>
    <template v-if="!isComplete">
      Загружается...
    </template>
    <template v-else-if="items.length > 0">
      <table class="table-custom">
        <thead>
        <tr>
          <th style="width:5%"></th>
          <th>Дата</th>
          <th>Контактное лицо</th>
          <th>Контакты</th>
          <th>Итог общения</th>
          <th>Статус работодателя</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item) in items" v-bind:key="item.id" @dblclick="editCard(item.id)">
          <td>
            <menu-component class="actions" :actions="actions(item)"/>
          </td>
          <td>{{ $momentFormat(item.dateMeeting, "DD.MM.YYYY") }}</td>
          <td>{{ item.contactPerson }}</td>
          <td>{{ item.contactInfo }}</td>
          <td>{{ item.result }}</td>
          <td>{{ item.employerStatus?.name }}</td>
        </tr>
        </tbody>
      </table>
    </template>
    <template v-else>
      <EmptyListMessage/>
    </template>
    <div class="mt-2">
      <button-component v-if="canEdit" @click='editCard(0)'>Создать</button-component>
    </div>
    <section class="modals">
      <modal-component v-if="modals.show" title="История контактов" @close="modals.show = false">
        <vacancy-history-card :vacancy-id="vacancyId" :card-id="modals.id" :is-readonly="modals.isReadonly"
                                @close="modals.show = false" @save="modals.show = false;loadPage();"/>
      </modal-component>
    </section>
  </div>
</template>
<script>
import API from '../api/vacancyHistory'
import Constants from '@/common/constants'
import ModalComponent from "@/common/ui/ModalComponent";
import MenuComponent from "../../../common/ui/components/page/MenuComponent";
import ButtonComponent from '@/common/ui/ButtonComponent'
import VacancyHistoryCard from "../views/VacancyHistoryCard";

export default {
  name: "VacancyTabHistory",
  components: {
    VacancyHistoryCard,
    MenuComponent,
    ModalComponent,
    ButtonComponent
  },
  props: {
    vacancyId: Number,
    canEdit: Boolean
  },
  data: () => ({
    items: [],
    isComplete: false,
    modals: {
      show: false,
      id: null,
      isReadonly: false
    }
  }),
  created() {
    this.loadPage();
  },
  watch: {
    vacancyId: function (/*newValue, oldValue*/) {
      this.loadPage();
    }
  },
  methods: {
    actions(item) {
      let result = [
        {
          title: 'Просмотр',
          icon: 'eye',
          click: () => this.viewCard(item.id)
        }
      ];
      if (this.canEdit) {
        result = result.concat([
          {
            title: 'Редактировать',
            icon: 'pen',
            click: () => this.editCard(item.id)
          },
          {
            title: 'Удалить',
            icon: 'trash',
            click: () => this.deleteCard(item.id)
          }
        ]);
      }
      return result;
    },
    loadPage() {
      if (!(this.applicantId > 0 || this.vacancyId > 0)) {
        return;
      }
      this.isComplete = false;
      API.search(this.vacancyId)
          .then((response) => {
            this.items = response.data;
            this.isComplete = true;
          });
    },
    viewCard(id) {
      this.modals.id = id;
      this.modals.show = true;
      this.modals.isReadonly = true;
    },
    editCard(id) {
      if (this.canEdit) {
        this.modals.id = id;
        this.modals.show = true;
        this.modals.isReadonly = false;
      } else {
        this.viewCard(id);
      }
    },
    deleteCard(id) {
      Constants.alert.fire(Constants.confirmOptions.delete).then((res) => {
        if (res.isConfirmed) {
          API.delete(id).then((response) => {
            Constants.alert.fire('Удаление', response.data.message, response.data.success ? 'success' : 'error');
            this.loadPage();
          });
        }
      });
    },
  },
};
</script>
